import { render, staticRenderFns } from "./500.vue?vue&type=template&id=747d2cda&scoped=true&"
var script = {}
import style0 from "./500.vue?vue&type=style&index=0&id=747d2cda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747d2cda",
  null
  
)

component.options.__file = "500.vue"
export default component.exports